class PlpFaqData extends HTMLElement {
  constructor() {
    super();
    this.questionsContent = this.querySelectorAll('.accordion__title');
    this.answersContent = this.querySelectorAll('.accordion__content');
    
    this.handleCollection = this.dataset.handleCollection;
  }

  connectedCallback() {
    this.fetchData();
  }

  async fetchData() {
    if(this.handleCollection === undefined || this.handleCollection === '') return;
    try {
      const response = await fetch(`https://api.wordlift.io/data/https/www.readers.com/collections/${this.handleCollection}`);
  
      if (!response.ok) {
        throw new Error(`Errore HTTP: ${response.status}`);
      }
  
      const data = await response.json();
 
      //find mainEntity data
      let d = data.filter(i => {
        if(i.hasOwnProperty('mainEntity')) {
          return i;
        }
      })

      this.renderProducts(d);
      // Commentato per evitare duplicazione dati strutturati FAQPage (WordLift bootstrap.js già li genera)
      // this.insertJsonLd(d);
      
    } catch (error) {
      this.style.display = "none";
      console.error("Errore nella fetch:", error);
    }
  }
  
  // Commentato per evitare duplicazione dati strutturati FAQPage
  // insertJsonLd(data) {
  //   const script = document.createElement("script");
  //   script.type = "application/ld+json";
  //   script.text = JSON.stringify({
  //     "@context": "https://schema.org",
  //     "@type": "FAQPage",
  //     "mainEntity": data[0]?.mainEntity || []
  //   });
  //   document.head.appendChild(script);
  // }

  renderProducts(data) {
    const answers = data[0].mainEntity;
    answers.forEach((answer, i) => {
      this.questionsContent[i].innerHTML = answer.name;
      this.answersContent[i].innerHTML = answer.acceptedAnswer.text;
    });

    // Hide empty accordion block
    this.answersContent.forEach((el, i) => {
      if(this.answersContent[i].innerHTML.trim() === "") {
        this.answersContent[i].closest('.accordion').classList.add('tw-hidden')
      }
    })
  }
}

customElements.define('plp-faq-data', PlpFaqData);